export default "__VITE_ASSET__65baa8fb__"